import {  GET_AR_INVENTORY_REQUEST,
	GET_AR_INVENTORY_SUCCESS,
	GET_AR_INVENTORY_ERROR } from "../actions/types";

export default function (state = [], action) {
	const { type, payload } = action;
	switch (type) {
		case GET_AR_INVENTORY_REQUEST:
			return {
				loading: true,
			};
		case GET_AR_INVENTORY_SUCCESS:
			return {
				...state,
				loading: false,
				payload
						};
		case GET_AR_INVENTORY_ERROR:
			return {
				...state,
				loading: false,
				payload,
			};

		default:
			return state;
	}
}
